export const LIST_FAVORITES = "favorites";
